import { FC, PropsWithChildren, useEffect } from 'react'
import { useNavigate } from 'react-router'

import { ROUTE_URL } from '@/router/constants'
import { useAuthStore } from '@/stores/useAuthStore'

export const Protected: FC<PropsWithChildren> = ({ children }) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const navigate = useNavigate()

  useEffect(() => {
    if (!isAuthenticated) {
      navigate(ROUTE_URL.LOGIN)
    }
  }, [isAuthenticated, navigate])

  if (!isAuthenticated) {
    return null
  }

  return children
}
